import { clientsUnitsDetailsStore } from '@store/clients/units/details/clients-units-details.store';
import { getClientUnitDetailsDataSource } from '@store/clients/units/details/clients-units-details.requests';

export class ClientsUnitsDetailsQuery {
  store = clientsUnitsDetailsStore;

  clientUnitDetails$ = getClientUnitDetailsDataSource.data$();
}

export const clientsUnitsDetailsQuery = new ClientsUnitsDetailsQuery();
